module.exports = __webpack_public_path__ + "img/Hawaii.c3d1c9bb.svg";